define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "../../models/UserContext", "../../models/PhoneNumberProviderModel", "./phoneNumberProviderActions"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, UserContext, PhoneNumberProviderModel, PhoneNumberProviderActions) {
    "use strict";
    var PhoneNumberProviderDetails = /** @class */ (function () {
        function PhoneNumberProviderDetails() {
            this.phoneNumberProviderId = ko.observable(0);
            this.editModel = ko.observable(new PhoneNumberProviderModel());
            this.actions = new PhoneNumberProviderActions();
            this.badRequest = false;
        }
        PhoneNumberProviderDetails.prototype.init = function (id) {
            var self = this;
            self.phoneNumberProviderId(id);
            self.badRequest = false;
            var getModelCall = tools.ajaxGet({
                url: urls_1.urls.phoneNumberProvidersGetById,
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new PhoneNumberProviderModel(result.Data));
                        if (UserContext.hasAccess("Admin") || UserContext.hasAccess("PhoneNumberProviders.Edit")) {
                            $("#ko-main-content").on("click", ".btn-edit", function (event) {
                                self.actions.editPhoneNumberProvider(self.editModel().Id(), self.editModel().Name(), self.editModel().Website());
                                event.preventDefault();
                            });
                        }
                        self.actions.saveCallback = function (data) {
                            self.editModel(new PhoneNumberProviderModel(data));
                            if (self.dataLogs) {
                                self.dataLogs.refreshLogs();
                            }
                        };
                    }
                    else {
                        self.badRequest = true;
                        log.error(result.Error);
                    }
                }
            });
            $.when(getModelCall).done(function (data) {
                $("#contextLoader").hide();
                if (self.badRequest) {
                    $("#notFoundContext").show();
                }
                else {
                    $("#mainContext").show();
                }
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                self.initLogs();
            });
        };
        PhoneNumberProviderDetails.prototype.initLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                self.dataLogs = new DataLogs("PhoneNumberProvider", self.phoneNumberProviderId());
                self.dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return PhoneNumberProviderDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith(urls_1.urls.phoneNumberProviderDetails)) {
            var id = urls_1.urls.getIdFromQueryString();
            if (id <= 0) {
                id = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize Phone Number Provider Details id: ".concat(id));
            $(function () {
                (new PhoneNumberProviderDetails()).init(id);
            });
        }
    }, 0);
    return PhoneNumberProviderDetails;
});
//# sourceMappingURL=phoneNumberProviderDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumberProviders/phoneNumberProviderDetails.js
// module id = 239
// module chunks = 2